/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
// unique elements
import Title from 'components/shared/title/title';
import BodyCopy from 'components/shared/bodycopy/bodycopy';
import InsticatorLogo from 'components/shared/logo/insticator/insticator_container';
import PartnerLogo from 'components/shared/logo/partner/partner_container';
// utils
import { trackEvent } from 'utils/tracking/tracking';
import { refreshAds } from 'utils/ads';
import { url } from 'utils/urls';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/screens/outofcontent/outofcontent_styles';
import { createStyles } from 'utils/styles';
import { preloadStyleImages } from "utils/preloader";
preloadStyleImages(styles);
const sheet = createStyles(styles, {link:false});



/* ========== ~~~~~~~~~~ ABOUT SCREEN: CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class OutOfContentScreen extends Component {
    // left over from when we had the sign in button
    // handleClick = (e) => {
    //     e.preventDefault();
    //     trackEvent('click', 'buttonSelected', null, {text: e.target.textContent, target:url.b2cURL, currentScreen: 'outOfContent'});
    //     refreshAds();
    //     window.open(url.b2cURL);
    // };
    partnerMessage = () => (
        <div className={`partnermessage`}>
            <PartnerLogo contentId={null} />
        </div>
    )
    fallbackMessage = () => (
        <div className={`fallbackmessage`}>
            <div className={`graphic ooc`} />
            <Title>{`Stay Connected`}</Title>
            <BodyCopy>
                <p>There is no more content at this time – stay tuned for daily updates!</p>
            </BodyCopy>
        </div>
    )
    render() {
        const logoSrc = this.props.settings.embedSettings.elements.partnerLogo.src;
        const showPartnerLogo = !!this.props.partnerLogo && logoSrc != null && logoSrc !== "" && logoSrc !== undefined;
        return(
            <div className={`${sheet.classes.outofcontentscreen} outofcontentscreen screen`}>
                <div className={`uniquescreen`}>
                    {showPartnerLogo ? this.partnerMessage() : this.fallbackMessage()}
                </div>
                <div className={`footer`}>
                    {!showPartnerLogo && <InsticatorLogo contentId={this.props.contentId} poweredBy={true} />}
                </div>
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default OutOfContentScreen;
